import { Check, X, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { api, errMsg } from "@/lib/api";
import { Avatar } from "@/components/PersonCard";
import { toast } from "sonner";

export const DeleteRequestCard = ({ d, user, onAction }) => {
  const act = async (kind) => {
    try {
      const { data } = await api.post(`/delete-requests/${d.request_id}/${kind}`);
      toast.success(kind === "reject" ? "Request rejected — entry kept" : data.status === "deleted" ? `${d.person_name} removed from the tree` : "Approval recorded");
      onAction();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const canApprove = user.can_vote && !d.i_approved && (user.is_admin || !d.mine);
  return (
    <div className="rounded-3xl border border-[#C62828]/30 bg-white p-6 flex flex-col md:flex-row gap-5 md:items-center" data-testid={`delete-card-${d.request_id}`}>
      <Avatar p={{ name: d.person_name, photo_url: d.photo_url, gender: d.gender }} size="w-14 h-14 text-lg shrink-0" />
      <div className="flex-1 min-w-0 space-y-1">
        <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#C62828] flex items-center gap-1"><Trash2 className="w-3 h-3" />Removal request</p>
        <p className="font-serif text-xl font-semibold">Remove {d.person_name}?</p>
        <p className="text-sm text-[#52635B]">“{d.reason}” — {d.requested_by}</p>
      </div>
      <div className="md:w-56 space-y-2">
        <p className="text-sm font-medium" data-testid={`delete-count-${d.request_id}`}>{d.approvals}/{d.needed} approvals</p>
        <Progress value={(d.approvals / d.needed) * 100} className="h-2" />
        <div className="flex gap-2 pt-1">
          {canApprove && <Button size="sm" onClick={() => act("approve")} className="rounded-full bg-[#C62828] hover:bg-[#A61F1F]" data-testid={`delete-approve-btn-${d.request_id}`}><Check className="w-4 h-4 mr-1" />{user.is_admin ? "Delete now" : "Agree"}</Button>}
          {d.i_approved && <span className="text-xs text-[#2E7D32] self-center">You agreed</span>}
          {user.is_admin && <Button size="sm" variant="outline" onClick={() => act("reject")} className="rounded-full" data-testid={`delete-reject-btn-${d.request_id}`}><X className="w-4 h-4 mr-1" />Keep</Button>}
        </div>
      </div>
    </div>
  );
};
